module.exports = __webpack_public_path__ + "img/Nicole+Jon-75.a5aa47a5.jpeg";